var profileConfig = {
    buyer: [
        {
            title: 'Loan Officer',
            path: 'buyer.lender'
        },
        {
            title: 'Buyer Agent',
            path: 'buyer.buyer_agent'
        }
    ],
    buyer_agent: [
        {
            title: 'Loan Officer',
            path: 'buyer.lender'
        },
        {
            title: 'Listing Agent',
            path: 'listing.owner'
        }
    ],
    listing_agent: [
        {
            title: 'Loan Officer',
            path: 'buyer.lender'
        },
        {
            title: 'Buyer Agent',
            path: 'buyer.buyer_agent'
        }
    ],
    loan_officer: [
        {
            title: 'Buyer Agent',
            path: 'buyer.buyer_agent'
        },
        {
            title: 'Listing Agent',
            path: 'listing.owner'
        }
    ]
};

module.exports = profileConfig;
